<div class="dialog-header">
  <div class="title-wrapper">
    <h3 mat-dialog-title class="title">
      <ng-container *ngIf="storeId; else selectStoresTitle">
        {{ 'catalog.searchModal.updateAvailabilityBtn' | translate }}
      </ng-container>
      <ng-template #selectStoresTitle>
        {{ 'catalog.bulkOutOfStock.selectStores' | translate }}
      </ng-template>
    </h3>
  </div>
</div>

<mat-dialog-content>
  <div class="messages">
    <txp-message [type]="messageType.SUCCESS"
                 data-qa-label="ShowSuccessMessage"
                 *ngIf="showSuccess"
                 [dismissible]="true"
                 (dismiss)="showSuccess = false">
        {{ successMessage }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="ShowErrorMessage"
                 *ngIf="showError"
                 [dismissible]="true"
                 (dismiss)="showError = false">
        {{ errorMessage }}
    </txp-message>
  </div>

  <div class="content">
    <!-- Selected Items -->
    <div class="selected-items" *ngIf="data?.catalogEntryNames?.length">
      <h4>{{ 'catalog.bulkOutOfStock.selectedItems' | translate }}</h4>
      <div class="selected-items-list">{{ data.catalogEntryNames.join(', ') }}</div>
    </div>

    <!-- Out of Stock Configuration -->
    <form class="out-of-stock-form" [formGroup]="form">
      <div class="set-out-of-stock">
        <mat-radio-group aria-label="Action" formControlName="action" class="action-radio-group">
          <mat-radio-button value="OUT">{{ 'catalog.bulkOutOfStock.action.out' | translate }}</mat-radio-button>
          <mat-radio-button value="IN">{{ 'catalog.bulkOutOfStock.action.in' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field class="out-of-stock-reason" *ngIf="this.form.get('action').value === 'OUT'">
        <mat-label>
            {{ 'store.taxes.itemAvailability.outOfStock.reason' | translate }}
        </mat-label>
        <input matInput
               data-qa-label="OutOfStockReason"
               maxlength="100"
               formControlName="reason">
      </mat-form-field>

      <div class="out-of-stock-until" *ngIf="this.form.get('action').value === 'OUT'">
          <div class="label" for="untilRadioGroup">
            {{ 'store.taxes.itemAvailability.outOfStock.until.label' | translate }}
          </div>
          <mat-radio-group
              class="until-radio-group"
              id="untilRadioGroup"
              formControlName="type">
              <mat-radio-button
                  value="RE_ENABLED"
                  data-qa-label="ReEnabledRadio">
                {{ 'store.taxes.itemAvailability.outOfStock.until.reEnabled' | translate }}
              </mat-radio-button>
              <mat-radio-button
                    value="SPECIFIED_DATE"
                    data-qa-label="SpecifiedDateRadio">
                {{ 'store.taxes.itemAvailability.outOfStock.until.specified' | translate }}
              </mat-radio-button>
            </mat-radio-group>

            <txp-type-selector *ngIf="this.form.get('type').value === 'SPECIFIED_DATE'"
                class="date-type-selector"
                [selected]="selectedDateType"
                [types]="dateTypeSelection"
                (select)="onSelectDateType($event)">
            </txp-type-selector>

            <div class="scheduler-container" formGroupName="scheduler">
              <mat-form-field *ngIf="this.form.get('type').value === 'SPECIFIED_DATE' && selectedDateType === 'date'"
                              class="out-until-date">
                  <mat-label>{{ 'store.taxes.itemAvailability.outOfStock.until.unavailable' | translate }}</mat-label>
                  <input matInput
                         [min]="minDate"
                         [ngxMatDatetimePicker]="untilTimePicker"
                         formControlName="until">
                  <mat-datepicker-toggle matSuffix [for]="$any(untilTimePicker)">
                  </mat-datepicker-toggle>
                  <ngx-mat-datetime-picker
                      #untilTimePicker
                      [showSpinners]="true"
                      [showSeconds]="true"
                      [stepHour]="1" [stepMinute]="1"
                      [stepSecond]="5"
                      [color]="color"
                      [enableMeridian]="true">
                      <ngx-mat-datepicker-actions>
                          <button color="primary"
                                  ngxMatDatepickerApply mat-icon-button
                              [attr.aria-label]="'form.button.select' | translate ">
                              <i class="tce-icon-checkmark"></i>
                          </button>
                      </ngx-mat-datepicker-actions>
                  </ngx-mat-datetime-picker>
                  <mat-hint>
                      {{ 'store.taxes.itemAvailability.outOfStock.until.hint' | translate }}
                  </mat-hint>
                  <mat-error *ngIf="this.form.get('scheduler').get('until').errors?.invalid">
                      {{ 'store.taxes.itemAvailability.outOfStock.until.error' | translate }}
                  </mat-error>
              </mat-form-field>
            </div>
      </div>
    </form>

    <!-- Store Selection -->
    <div class="store-selection" *ngIf="!storeId">
      <h4>{{ 'store.bulkOutOfStock.selectStores' | translate }}</h4>
      <mat-form-field class="search-input">
        <i matPrefix class="tce-icon-search"></i>
        <input matInput
               [placeholder]="'store.grid.search' | translate"
               [formControl]="storeFilterControl">
      </mat-form-field>

      <div class="stores-table" *ngIf="!isLoading">
        <table mat-table [dataSource]="storeDataSource" matSort class="select-stores-list">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="hasSelection() && isAllSelected()"
                            [indeterminate]="hasSelection() && !isAllSelected()"
                            data-qa-label="MasterToggleCheckBox"
                            [attr.aria-label]="'Select all stores'">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let store">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="onStoreSelectionChange(store, $event.checked)"
                            [checked]="isStoreSelected(store)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'store.grid.store' | translate }} </th>
            <td mat-cell *matCellDef="let store"> {{ store.name }} </td>
          </ng-container>

          <ng-container matColumnDef="storeNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'store.grid.number' | translate }} </th>
            <td mat-cell *matCellDef="let store"> {{ store.storeNumber }} </td>
          </ng-container>

          <ng-container matColumnDef="storeStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'store.grid.storeStatus' | translate }} </th>
            <td mat-cell *matCellDef="let store">
              <txp-badge *ngIf="store.storeStatus"
                           [type]="store.storeStatus">
                {{ 'store.grid.onboardingStatus.' + store.storeStatus | translate }}
              </txp-badge>
            </td>
          </ng-container>

          <ng-container matColumnDef="storeAddress">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'store.grid.address' | translate }} </th>
            <td mat-cell *matCellDef="let store"> {{ store.storeAddress }} </td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'store.grid.city' | translate }} </th>
            <td mat-cell *matCellDef="let store"> {{ store.city }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="storeDisplayColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: storeDisplayColumns"></tr>
        </table>
      </div>
      <txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <txp-button [style]="buttonStyle.PRIMARY"
              [size]="buttonSize.LARGE"
              [loading]="isUpdating"
              [disabled]="!form.valid || (!storeId && selectedStores.length === 0) || catalogEntryIds.length === 0"
              (click)="handleBulkOutOfStock()">
      {{ 'form.button.update' | translate }}
  </txp-button>
  <txp-button [style]="buttonStyle.SECONDARY"
              [size]="buttonSize.LARGE"
              [disabled]="isLoading || isUpdating"
              (click)="handleCancel()">
      {{ 'form.button.cancel' | translate }}
  </txp-button>
</mat-dialog-actions>
